import { LayoutWithNavigationBar } from "../../../layouts/layout-with-navigation-bar";
import { MainView } from "../../../views/inbound/register";

export default function Inbound_RegisterPage(props) {
    return (
        <>
            <LayoutWithNavigationBar>
                <MainView />
            </LayoutWithNavigationBar>
        </>
    );
}